export default "__VITE_ASSET__FTtSJtjR9ZCul8MOVNG7Vw__"